import createLogger from './logging/create-logger';

const logger = createLogger();

export const log = (message, obj) => logger.log(message, obj);
export const warn = (message, obj) => logger.warn(message, obj);
export const event = (message, obj) => logger.event(message, obj);
export const error = (message, obj) => logger.error(message, obj);
